module.exports = __webpack_public_path__ + "static/media/discover.a3bc3f5d.svg";